import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/sharePopout.js';
import Store from 'store/store';
import getCopyWithParams from 'utils/getCopyWithParams';
// import s from 'components/bolt/header/sharePopout.sss';

export default class SharePopout extends BaseComp.default {

	getShareURL() {
		const activePage = Store.get().activePage || '';
		if (activePage === 'megaverse') {
			return 'https://www.EnterTheMegaverse.com';
		}
		return super.getShareURL();
	}

	getSharingLink (type) {
		const activePage = Store.get().activePage || '';
		if (activePage === 'megaverse') {
			this.shareCopy = 'Despicable Me 4 is just the beginning. Prepare for 100 years of Mega Minion greatness.';
		} else {
			const data = this.props?.appData?.header?.powsterHeader?.share || {};
			this.shareCopy = getCopyWithParams(this.props.appData?.copy?.baseCopy, data.socialCopy || '$SOCIAL_COPY');
		}
		return super.getSharingLink(type);
	}

}